// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__o12ED","content":"Loading_content__hpEPt","content-loaded":"Loading_content-loaded__ZWQBD","result-button":"Loading_result-button__1i9MG"};